export default __webpack_public_path__ + "static/media/remedy_coffee_2.763cee5d.webp";